/**
 * The Graph PAGE's snapshot: the live stores plus the vault (names of DB
 * connections and SSH hosts, only while unlocked, "__" items hidden).
 *
 * Kept out of graphSnapshot.js on purpose — the MCP graph tools import that
 * module, and MCP may never list vault item names (D4). Nothing under
 * src/mcp may import this file.
 */
import { invoke } from '@tauri-apps/api/core';
import { useCollectionsStore } from '../store/collectionsStore';
import { useVariablesStore } from '../store/variablesStore';
import { readGraphSnapshot } from './graphSnapshot';

const isHiddenVaultItem = (item) => String(item?.name || '').startsWith('__');

async function vaultItems() {
  const status = await invoke('vault_status');
  if (!status?.unlocked) return null;
  const list = await invoke('vault_list');
  return (Array.isArray(list) ? list : []).filter((it) => it && !isHiddenVaultItem(it));
}

export function readAppGraphSnapshot() {
  return readGraphSnapshot({
    collections: useCollectionsStore.getState().collections || [],
    environments: useVariablesStore.getState().environments || [],
    readVault: vaultItems,
  });
}
